import React from "react";
import AccoutSetting from "../../components/AccountSettings";
import Header from "../../components/Header";
import RightSideAccountSetting from "../../components/RightAccountSetting"; // Consider renaming to match the LeftSide component for consistency
import { PROFILE } from "../../constants/settingsStrings.js";
import Bottombar from "../../components/Bottombar";

function EditProfile() {
  return (
    <div className="dark:bg-black h-[100vh] overflow-y-hidden">
    <div className=" overflow-y-hidden">
      <div className="md:block hidden">
        <Header />
      </div>

      <div className="sm:flex relative h-full justify-center items-center sm:space-x-10">
        <h2 className="mb-2 font-sans absolute font-semibold hidden md:block dark:text-white left-60 top-8">
          Account Settings
        </h2>
        <div className="bg-[#2A71E8] h-10 w-full mb-5 sm:hidden"></div>
        <div className="">
          <AccoutSetting active={PROFILE} />
        </div>

        <div className="md:block hidden">
          <RightSideAccountSetting />
        </div>
      </div>
      <Bottombar activeBar={'settings'} />
    </div>
    </div>
  );
}

export default EditProfile;
